import { PageFooterData } from 'components/PageFooter/types/PageFooterData';
import { getMainInternshipsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainInternshipsSearchRoutePath';
import { getMainJobsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainJobsSearchRoutePath';
import { getMainOrgSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainOrgSearchRoutePath';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';
import { mainPostAListingRoute } from 'modules/main/main.routes';

export const pageFooterDataEn: PageFooterData = {
  findAJob: {
    title: 'Find a Job',
    links: [
      {
        type: 'jobs',
        title: 'Jobs',
        href: getMainJobsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'internships',
        title: 'Internships',
        href: getMainInternshipsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'organizations',
        title: 'Organizations',
        href: getMainOrgSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'salary-explorer',
        title: 'Nonprofit Salary Explorer',
        href: '/nonprofit-salary-explorer',
      },
      {
        type: 'career-advice',
        title: 'Career Advice',
        href: '/en/careers',
      },
    ],
  },
  takeAction: {
    title: 'Take Action',
    links: [
      {
        type: 'volops',
        title: 'Volunteer',
        href: getMainVolopsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'events',
        title: 'Attend an Event',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'petitions',
        title: 'Sign a Petition',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['PETITION'] },
        }),
      },
      {
        type: 'loans',
        title: 'Fund a Loan',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['LOAN'] },
        }),
      },
      {
        type: 'donations',
        title: 'Make a Donation',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
      {
        type: 'idealist-movement',
        title: 'Idealist Action Incubator',
        href: '/en/action-incubator',
      },
    ],
  },
  postOnIdealist: {
    title: 'Post on Idealist',
    links: [
      {
        type: 'post-a-listing',
        title: 'Post a listing',
        href: mainPostAListingRoute.with({}),
      },
      {
        type: 'create-org',
        title: 'Add your Organization',
        href: '/organizations/create',
      },
      {
        type: 'create-community-group',
        title: 'Add your Community Group',
        href: '/organizations/create',
      },
      {
        type: 'employer-resources',
        title: 'Employer Resources',
        href: '/en/orgs/resources',
      },
      {
        type: 'for-grad-schools',
        title: 'For Grad Schools',
        href: '/grad-schools/exhibit',
      },
    ],
  },
  aboutUs: {
    title: 'About Us',
    links: [
      {
        type: 'our-mission',
        title: 'Our Mission',
        href: '/en/about',
      },
      {
        type: 'our-team',
        title: 'Our Team',
        href: '/en/about/our-team',
      },
      {
        type: 'donate',
        title: 'Donate to Idealist',
        href: '/en/donate',
      },
    ],
  },
  learnMore: {
    title: 'Learn More',
    links: [
      {
        type: 'help-center',
        title: 'Help',
        href: '/en/help',
      },
      {
        type: 'contact-us',
        title: 'Contact Us',
        href: '/en/about/contact',
      },
      {
        type: 'terms-of-service',
        title: 'Terms of Service',
        href: '/en/terms-of-service',
      },
      {
        type: 'privacy-policy',
        title: 'Privacy Policy',
        href: '/en/privacy-policy',
      },
      {
        type: 'site-map',
        title: 'Site Map',
        href: '/en/sitemap',
      },
    ],
  },
};
